<template>
  <div class="tickets-dashboard-graph-container">
    <div ref="ticketsResolutionGraph" style="width: 100%; height: 100%; overflow: hidden;"></div>
  </div>
</template>

<script>
const echarts = require('echarts');
import ticketDashboardMixins from '../../../../../mixins/ticketDashboardMixins';
export default {
  name: "TicketsResolutionGraph",
  mixins: [ticketDashboardMixins],
  data() {
    return {
      ticketResolutionGraphInstance: '',
      option: {
        color: ['#D26300', '#E29D5A', '#333333', '#F9CB9C'],

        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          right: '15%',
          y: 40,
          y2: 100,
        },
        // toolbox: {
        //   feature: {
        //     dataView: { show: true, readOnly: false },
        //     restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        legend: {
          data: ['Within SLA', 'SLA Violation', 'SLA %', 'Violation %'],
          textStyle: {
            fontSize: '16',
          },
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            // prettier-ignore
            data: ['East', 'West', 'North', 'South']
          }
        ],
        yAxis: [
          {
            type: 'value',
            // name: 'Within SLA',
            name: '',
            min: 0,
            max: 50,
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#333333'
              }
            },
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            // name: 'SLA Violation',
            name: '',
            min: 0,
            max: 50,
            position: 'left',
            alignTicks: true,
            offset: 80,
            axisLine: {
              show: true,
              lineStyle: {
                // color: '#E29D5A'
                color: 'transparent'
              }
            },
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            // name: 'SLA %',
            name: '',
            min: 0,
            interval: 25,
            max: 100,
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#333333'
              }
            },
            axisLabel: {
              formatter: '{value} %'
            }
          },
          {
            type: 'value',
            // name: 'Violation %',
            name: '',
            min: 0,
            interval: 25,
            max: 100,
            position: 'right',
            alignTicks: true,
            offset: 80,
            axisLine: {
              show: true,
              lineStyle: {
                // color: '#F9CB9C'
                color: 'transparent'
              }
            },
            axisLabel: {
              formatter: '{value} %'
            }
          },
        ],
        series: [
          {
            name: 'Within SLA',
            type: 'bar',
            yAxisIndex: 0,
            barWidth: 50,
            data: [
              2.0, 4.9, 7.0, 23.2
            ]
          },
          {
            name: 'SLA Violation',
            type: 'bar',
            yAxisIndex: 1,
            barWidth: 50,
            data: [
              2.6, 5.9, 9.0, 26.4
            ]
          },
          {
            name: 'SLA %',
            type: 'line',
            yAxisIndex: 2,
            lineStyle: {
              type: 'dashed',
              width: 3,
              gap: 0
            },
            data: [2.0, 2.2, 3.3, 4.5]
          },
          {
            name: 'Violation %',
            type: 'line',
            yAxisIndex: 3,
            lineStyle: {
              type: 'dashed',
              width: 3,
              gap: 0
            },
            data: [5.0, 22.2, 7.3, 9.5]
          },
        ]
      }
    };
  },
  computed: {
    graphMaxInterVal() {
      let max = 50;
      if(this.ticket_data && this.ticket_data.length) {
        let totalTickets = this.ticket_data.map(el => el.within_sla);
        let openTickets = this.ticket_data.map(el => el.violation);
        let topTotalTickets =  Math.max(...totalTickets);
        let topOpenTickets =  Math.max(...openTickets);
        if(topTotalTickets > topOpenTickets) {
          max = topTotalTickets;
        } else {
          max = topOpenTickets;
        }
      }
      max = this.roundNearestTen(max);
      return max;
    }
  },
  watch: {
    ticket_data(newValue, oldValue) {
      this.reRenderGraph(newValue);
    }
  },
  created() {
    setTimeout(() => {
      this.initGraph();
    }, 80);
  },
  methods: {
    initGraph() {
      let chartContainer = this.$refs.ticketsResolutionGraph;
      this.ticketResolutionGraphInstance = echarts.init(chartContainer);
      this.ticketResolutionGraphInstance.setOption(this.option);
      this.ticketResolutionGraphInstance.showLoading();
    },
    reRenderGraph(data) {
      let agents = [];
      let withinSLA = [];
      let slaViolation = [];
      let slaPercentage = [];
      let violationPercentage = [];
      for(let i = 0; i < data.length; i++) {
        let item = data[i];
        agents.push(this.$options.filters.titleCase(item.name));
        withinSLA.push(item.within_sla);
        slaViolation.push(item.violation);
        slaPercentage.push(item.within_sla_percentage);
        violationPercentage.push(item.violation_percentage);
      }
      // x axis labels
      this.option.xAxis[0].data = [...agents];

      this.option.yAxis[0].max = this.graphMaxInterVal;
      this.option.yAxis[1].max = this.graphMaxInterVal;

      // Plotting within SLA data
      this.option.series[0].data = [...withinSLA];
      // Plotting within SLA Violation data
      this.option.series[1].data = [...slaViolation];
      // Plotting within SLA Percentage data
      this.option.series[2].data = [...slaPercentage];
      // Plotting within Violation Percentage data
      this.option.series[3].data = [...violationPercentage];
      this.ticketResolutionGraphInstance.clear();
      this.ticketResolutionGraphInstance.setOption(this.option);
			this.ticketResolutionGraphInstance.hideLoading();
    },
    roundNearestTen(num) {
      return Math.ceil(num / 5) * 5;
    }
  }
}
</script>